import React from 'react';
import { ProSidebar, Menu, MenuItem, SubMenu, SidebarHeader } from "react-pro-sidebar";
import { Link } from 'react-router-dom';
import './Sidebar.scss';

export default function Sidebar() {
  const logout = () => {
    sessionStorage.removeItem('loggedInUser');
    window.location.reload();
  }
    return (
        <ProSidebar 
        // collapsed={true}
        style={{ minHeight: "100vh" }}
        >
          <SidebarHeader>
           <h5 className="text-center mt-4">Ahle Haq Dashboard</h5> 
          </SidebarHeader>
            <Menu iconShape="square">

              <SubMenu title="Masala">
                <MenuItem>
                  <Link to="/"> Add Masala</Link>
                </MenuItem>
                <MenuItem>
                  <Link to="/admin/allMasala"> All Masala</Link>
                </MenuItem>
              </SubMenu>
              <SubMenu title="Boyan">
                <MenuItem>
                  <Link to="/admin/addBoyan"> Add Boyan</Link>
                </MenuItem>
                <MenuItem>
                  <Link to="/admin/AllBoyan"> All Boyan</Link>
                </MenuItem>
              </SubMenu>
              <SubMenu title="Doa">
                <MenuItem>
                  <Link to="/admin/addDoa"> Add Doa</Link>
                </MenuItem>
                <MenuItem>
                  <Link to="/admin/allDoa"> All Doa</Link>
                </MenuItem>
              </SubMenu>
              <SubMenu title="Probondho">
                <MenuItem>
                  <Link to="/admin/addProbondho"> Add Probondho</Link>
                </MenuItem>
                <MenuItem>
                  <Link to="/admin/allProbondho"> All Probondho</Link>
                </MenuItem>
              </SubMenu>
              <SubMenu title="Salah">
                <MenuItem>
                  <Link to="/admin/addSalah"> Add Salah</Link>
                </MenuItem>
                <MenuItem>
                  <Link to="/admin/allSalah"> All Salah</Link>
                </MenuItem>
              </SubMenu>
              <SubMenu title="Kitab">
                <MenuItem>
                  <Link to="/admin/addKitab"> Add Kitab</Link>
                </MenuItem>
                <MenuItem>
                  <Link to="/admin/allKitab"> All Kitab</Link>
                </MenuItem>
                <MenuItem>
                  <Link to="/admin/allKitabName"> All Book Name</Link>
                </MenuItem>
              </SubMenu>
               <MenuItem>
                <Link to="/admin/allCategory"> Show all category</Link>
              </MenuItem>
              <MenuItem>
                <button
                  type="button"
                  className="btn btn-light rounded mx-auto"
                  onClick={() => logout()}
                >
                  Log out
                </button>
              </MenuItem>
            </Menu>
          </ProSidebar>
    )
}
